import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PrimaryButton from "../Buttons/PrimaryButton";
import { Link } from "react-router-dom";

import "../../../css/Cards.scss";

function LookingForSupport(props) {
  return (
    <section className={`looking-for-support ${props.addClass}`}>
      <Container>
        <Row>
          <Col md={{ span: 12 }}>
            <div className="contained cloud-blue-bg d-flex align-items-center flex-column flex-lg-row">
              <picture>
                <img
                  src="/images/Platey_Ryder_Bubbles.png"
                  alt="Doptelet Platelet Character Blowing Bubbles"
                  className="mb-4 d-lg-none d-sm-inline-block free-hugs"
                />
              </picture>
              <div className="col-lg-8 pl-0 pr-0 d-flex flex-column align-self-stretch">
                <h2>Looking for support to manage your chronic ITP?</h2>
                <p className="flex-grow-1">
                  Sign up to receive tools and tips, including a free journal to help you track your platelet counts, symptoms, and treatment—plus you’ll get some surprises, too!
                </p>
                <Link
                  to="/support-and-resources/living-with-itp/"
                  className="btn btn-arrow btn-primary align-self-start">
                  <span>GET ITP TIPS</span>
                </Link>
              </div>
              <picture className="flex-grow-1">
                <img
                  src="/images/Platey_Ryder_Bubbles.png"
                  alt="Doptelet Platelet Character Blowing Bubbles"
                  className="d-none d-lg-block m-auto"
                />
              </picture>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default LookingForSupport;
